import * as React from "react";
import { useContext } from "react";
import * as Immutable from "immutable";
import InteractiveContext from "views/components/contexts/InteractiveContext";
import useMessage from "views/hooks/useMessage";
import MessagePermalinkButton from "views/components/common/MessagePermalinkButton";
import FieldTypesContext from "views/components/contexts/FieldTypesContext";
import TypeSpecificValue from "views/components/TypeSpecificValue";
import FieldTypeMapping from "views/logic/fieldtypes/FieldTypeMapping";
import FieldType from "views/logic/fieldtypes/FieldType";
import SingleMessageFieldTypesProvider from "views/components/fieldtypes/SingleMessageFieldTypesProvider";
import { Spinner } from "components/common";
import MessageFieldsFilter from "logic/message/MessageFieldsFilter";
import StreamsContext from "contexts/StreamsContext";
import MessageSummary from "search/MessageSummary";
import EvidenceFields from "./EvidenceFields";
import EvidenceCardFoundation from "./EvidenceCardFoundation";
const LogCardFields = ({ fields, similarFieldsFilter, evidenceId }) => {
  var _a;
  const { streams: messageStreams, timestamp } = fields;
  const streams = useContext(StreamsContext);
  const streamsMap = Immutable.Map(Object.fromEntries(streams.map((stream) => [stream.id, stream])));
  const fieldTypesStreams = messageStreams == null ? void 0 : messageStreams.filter((streamId) => streamsMap.has(streamId));
  const { matching_fields: similarFields } = (_a = similarFieldsFilter == null ? void 0 : similarFieldsFilter.fields.logs.find(
    ({ message: { id } }) => id === evidenceId
  )) != null ? _a : { matching_fields: [] };
  return /* @__PURE__ */ React.createElement(SingleMessageFieldTypesProvider, { streams: fieldTypesStreams, timestamp }, /* @__PURE__ */ React.createElement(FieldTypesContext.Consumer, null, ({ all }) => {
    if (all.size === 0) {
      return /* @__PURE__ */ React.createElement(Spinner, null);
    }
    return /* @__PURE__ */ React.createElement(
      EvidenceFields,
      {
        similarFieldsFilterValue: similarFields,
        renderFieldValue: (fieldName, fieldValue) => {
          var _a2;
          return /* @__PURE__ */ React.createElement(
            TypeSpecificValue,
            {
              field: fieldName,
              value: fieldValue,
              type: (_a2 = all == null ? void 0 : all.find(
                (t) => t.name === fieldName,
                void 0,
                FieldTypeMapping.create(fieldName, FieldType.Unknown)
              )) == null ? void 0 : _a2.type
            }
          );
        },
        fields
      }
    );
  }));
};
const EvidenceLogCard = ({
  evidence,
  onResetShowSimilar,
  onShowSimilar,
  similarFieldsFilter
}) => {
  const { data: message, isInitialLoading } = useMessage(evidence.entity.index, evidence.id);
  const filteredMessageFields = (message == null ? void 0 : message.fields) ? MessageFieldsFilter.filterFields(message.fields) : void 0;
  if (isInitialLoading) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(InteractiveContext.Provider, { value: false }, /* @__PURE__ */ React.createElement(
    EvidenceCardFoundation,
    {
      title: /* @__PURE__ */ React.createElement(
        MessageSummary,
        {
          messageFields: filteredMessageFields,
          renderMessageRow: () => filteredMessageFields.message,
          hideOverflow: true
        }
      ),
      onResetShowSimilar,
      actions: /* @__PURE__ */ React.createElement(MessagePermalinkButton, { messageIndex: message == null ? void 0 : message.index, messageId: message == null ? void 0 : message.id }),
      onShowSimilar,
      hasSimilarFieldsFilter: !!similarFieldsFilter,
      evidence,
      isHighlighted: (similarFieldsFilter == null ? void 0 : similarFieldsFilter.targetEvidence.id) === evidence.id
    },
    filteredMessageFields && /* @__PURE__ */ React.createElement(
      LogCardFields,
      {
        fields: filteredMessageFields,
        similarFieldsFilter,
        evidenceId: evidence.id
      }
    )
  ));
};
export default EvidenceLogCard;
